import React from 'react';
import ReferenceGenerator from '../../components/ReferenceGenerator';
import { NOTIFICATIONS_URL } from '../../constants/urls';

export default function AdminNotifications() {
  return <ReferenceGenerator url={NOTIFICATIONS_URL} canDelete={false} canCreate={false} checkArchive={false} />;
}
